import {createProjectModel} from 'crm/utils/project-model'
import {
    getChannels,
    updateChannel,
    addChannel,
    deleteChannel,
    getDrainageCont,
    setDrainageCont,
} from './service'

const model = createProjectModel({
    projectNamespace: 'drainageChannelCode',

    state: {
        channelList: [],
        drainageCont: null,
    },

    effects: {
        // 获取渠道列表
        *getChannels(xx, {call, put}) {
            const res = yield call(getChannels)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.channelList = res?.data
                },
            })

            return res
        },

        // 更新渠道
        *updateChannel({payload}, {call}) {
            return yield call(updateChannel, payload)
        },

        // 添加渠道
        *addChannel({payload}, {call}) {
            return yield call(addChannel, payload)
        },

        // 删除渠道
        *deleteChannel({payload}, {call}) {
            return yield call(deleteChannel, payload)
        },

        // 获取引流的内容
        *getDrainageCont({payload}, {call, put}) {
            const res = yield call(getDrainageCont, payload)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.drainageCont = res?.data
                },
            })

            return res
        },

        // 设置引流的内容
        *setDrainageCont({payload}, {call}) {
            return yield call(setDrainageCont, payload)
        },
    },
})

export default model
